import { createFileRoute } from "@tanstack/react-router";
import LpInstagram from "@/pages/LpInstagram";
import { SITE_URL } from "@/lib/site-url";

const URL = `${SITE_URL}/en/lp/instagram`;
const ES_URL = `${SITE_URL}/lp/instagram`;
const SHARE_TITLE = "Grow your street-level business";
const SHARE_DESC = "The support and method many owners don't have. Try it free.";
const TITLE = "Don't run your business alone | Retail Lemon";
const DESCRIPTION =
  "Panel, method and support for high-street businesses: cash flow, team, premises and priorities. Join early access.";

export const Route = createFileRoute("/en/lp/instagram")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: SHARE_TITLE },
      { property: "og:description", content: SHARE_DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "en_US" },
      { property: "og:image", content: `${SITE_URL}/og-retail-lemon.jpg` },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: SHARE_TITLE },
      { name: "twitter:description", content: SHARE_DESC },
      { name: "twitter:image", content: `${SITE_URL}/og-retail-lemon.jpg` },
      {
        name: "robots",
        content: "index, follow, max-image-preview:large, max-snippet:-1",
      },
    ],
    links: [
      { rel: "canonical", href: URL },
      { rel: "alternate", hrefLang: "es", href: ES_URL },
      { rel: "alternate", hrefLang: "en", href: URL },
      { rel: "alternate", hrefLang: "x-default", href: ES_URL },
    ],
  }),
  component: LpInstagram,
});
